/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _page_blog__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./page.blog */ "./src/js/page.blog.js");
/* harmony import */ var _page_blog__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_page_blog__WEBPACK_IMPORTED_MODULE_0__);

$(window).on('load', function () {
  $('.blog-cat-page .blog-item').each(function () {
    var storage = jQuery(' .image-container img', this).attr('src');
    $('.image-container', this).css('background', "url('".concat(storage, "') #6F5980 center/cover no-repeat"));
  });
});
$('.accordion-item').click(function () {
  if ($(this).hasClass('shown')) {
    $(this).removeClass('shown');
    $(this).find('.a-answer').slideUp(350);
  } else {
    $('.accordion-item').removeClass('shown');
    $('.accordion-item > .a-answer').slideUp(350);
    $(this).addClass('shown');
    $(this).find('.a-answer').slideDown(350);
  }
});

/***/ }),

/***/ "./src/js/page.blog.js":
/*!*****************************!*\
  !*** ./src/js/page.blog.js ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

$(document).ready(function () {
  $('.more-button').on('click', function (e) {
    e.preventDefault();
    var tab = $(this).attr('data-tab');
    var items = '';
    $("textarea[data-tab=".concat(tab, "]")).each(function (index, value) {
      if (index >= 8) return false;
      items += convertTextarea($(this).text(), tab, $(this).attr('data-excerpt'), $(this).attr('data-cat'), $(this).attr('data-url'), $(this).attr('data-date'));
      $(this).remove();
    });
    $("section[data-tab=".concat(tab, "] .guide-wrapper")).append(items);
    var itemLength = $("textarea[data-tab=".concat(tab, "]"));

    if (itemLength.length <= 0) {
      $(this).remove();
    }
  });

  function convertTextarea(data, tab, excerpt, cat, url, date, icon) {
    var data = JSON.parse(data);
    console.log(data);
    var html = "<div class=\"guide-item\" data-tab=\"".concat(tab, "\">\n        <a href=\"").concat(url, "\">\n        <div class=\"blog-img\" style=\"background-image: url(").concat(data.image.src, ")\"></div>\n          <p class=\"article-title\">").concat(data.title, "</p>\n   <span style=\"font-size: 13px; color: #666;\"> <i>Published: " + date + "</i></span>\n     <p>").concat(excerpt, "</p>\n    <div class=\"readmore-btn\"><span>Read More</span></div>\n    </a>\n    </div>");
    return html;
  }
});

/***/ }),

/***/ "./src/scss/app.scss":
/*!***************************!*\
  !*** ./src/scss/app.scss ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/*!*************************************************!*\
  !*** multi ./src/js/app.js ./src/scss/app.scss ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! D:\Projects\C9\Shopify Store Development\_Lunada\LIVE THEME\src\js\app.js */"./src/js/app.js");
module.exports = __webpack_require__(/*! D:\Projects\C9\Shopify Store Development\_Lunada\LIVE THEME\src\scss\app.scss */"./src/scss/app.scss");


/***/ })

/******/ });